export default {
  root: {
    '&$disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto'
    }
  }
}
